(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('erten-hero-slideshow')) {
  customElements.define('erten-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true') return;
      this.slides = [...this.querySelectorAll('.erten-hero-slide')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = Boolean(this.dataset.editorSlide) || this.dataset.autoplay !== 'true' || this.motion.matches;
      this.events = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, { signal: this.events.signal });
      this.controls = this.querySelector('.erten-hero-controls');
      this.toggle = this.querySelector('[data-toggle]');
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.controls.hidden = false;
      on(this.querySelector('[data-prev]'), 'click', () => this.go(this.index - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.go(this.index + 1));
      this.dots.forEach(dot => on(dot, 'click', () => this.go(Number(dot.dataset.slide))));
      on(this.toggle, 'click', () => { this.paused = !this.paused; this.schedule(); });
      on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.schedule(); });
      on(this.controls, 'keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.go(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      on(this, 'touchstart', event => { this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null; });
      on(this, 'touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.swipedAt = Date.now(); this.go(this.index + (dx < 0 ? 1 : -1)); }
      });
      this.addEventListener('click', event => { if (Date.now() - (this.swipedAt || 0) < 500) { event.preventDefault(); event.stopPropagation(); } }, { capture: true, signal: this.events.signal });
      const editorIndex = this.slides.findIndex(slide => slide.dataset.slideNumber === this.dataset.editorSlide);
      if (editorIndex >= 0) this.go(editorIndex);
      else this.schedule();
    }
    go(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === this.index); slide.setAttribute('aria-hidden', String(i !== this.index)); });
      this.querySelectorAll('[data-slide-content], [data-slide-link]').forEach(content => { content.hidden = Number(content.dataset.slideContent ?? content.dataset.slideLink) !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
      this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.timer = setTimeout(() => this.go(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 5000));
    }
    disconnectedCallback() { clearTimeout(this.timer); this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
if (!customElements.get('erten-quad-measure')) {
    customElements.define('erten-quad-measure', class extends HTMLElement {
      connectedCallback() {
        const grid = this.closest('[ref="grid"]');
        const card = grid?.querySelector(':scope > [data-product-id]');
        if (!grid || !card) return;
        this.observer = new ResizeObserver(() => {
          const height = card.getBoundingClientRect().height;
          const gap = parseFloat(getComputedStyle(grid).rowGap) || 0;
          this.parentElement.style.setProperty('--erten-row-height', height + 'px');
          this.parentElement.style.setProperty('--erten-row-gap', gap + 'px');
        });
        this.observer.observe(card);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
if (!customElements.get('erten-product-help')) {
  customElements.define('erten-product-help', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(`shopify-section-${this.dataset.section}`);
      this.details = this.section?.querySelector('.product-details');
      if (!this.details) return;
      this.guide = this.querySelector('.erten-fit-guide');
      this.summary = this.querySelector('.erten-purchase-summary');
      this.facts = this.querySelector('.erten-product-facts');
      const price = this.details.querySelector('product-price');
      if (this.facts && price) price.after(this.facts);
      this.guide.querySelectorAll('[data-fit-table] table').forEach(table => {
        const rows = Array.from(table.rows, row => Array.from(row.cells, cell => cell.textContent.trim()));
        if (!rows.length) return;
        const clean = document.createElement('table');
        const head = clean.createTHead().insertRow();
        rows.forEach(row => { const cell = document.createElement('th'); cell.scope = 'col'; cell.textContent = row[0]; head.append(cell); });
        const body = clean.createTBody();
        for (let i = 1; i < rows[0].length; i++) {
          const row = body.insertRow();
          rows.forEach((values, index) => { const cell = document.createElement(index ? 'td' : 'th'); if (!index) cell.scope = 'row'; cell.textContent = values[i] || '—'; row.append(cell); });
        }
        table.replaceWith(clean);
      });
      this.picker = this.details.querySelector('variant-picker');
      this.picker?.before(this.guide);
      this.details.querySelector('product-form-component')?.after(this.summary);
      this.sticky = this.section.querySelector('sticky-add-to-cart');
      this.chosen = this.dataset.needsChoice !== 'true' || new URL(location.href).searchParams.has('variant');
      this.sync = () => {
        this.sticky?.classList.toggle('erten-needs-size', !this.chosen);
        const button = this.sticky?.querySelector('button');
        if (button) {
          button.dataset.selectLabel = this.dataset.selectLabel;
          if (!this.chosen) button.setAttribute('aria-label', this.dataset.selectLabel);
          else button.removeAttribute('aria-label');
        }
      };
      this.onChange = event => {
        if (event.target.closest('variant-picker')) { this.chosen = true; this.sync(); }
      };
      this.onClick = event => {
        if (event.target.closest('variant-picker') && event.target.closest('input,select,label,button')) { this.chosen = true; this.sync(); }
        if (event.target.closest('.erten-policy-open')) {
          const policy = Array.from(this.details.querySelectorAll('details')).find(item => /kargo/i.test(item.querySelector('summary')?.textContent || ''));
          if (policy) { policy.open = true; policy.scrollIntoView({block:'center',behavior:'smooth'}); policy.querySelector('summary').focus(); }
        }
        if (!this.chosen && event.target.closest('.erten-sticky-select')) {
          event.preventDefault(); event.stopImmediatePropagation();
          const picker = this.details.querySelector('variant-picker');
          picker?.scrollIntoView({block:'center',behavior:'smooth'});
          picker?.querySelector('input,select,button')?.focus({preventScroll:true});
        }
      };
      this.section.addEventListener('change', this.onChange);
      this.section.addEventListener('click', this.onClick, true);
      this.sync();
      let tries = 0;
      this.formsTimer = setInterval(() => {
        const root = document.querySelector('shopify-forms-embed')?.shadowRoot;
        if (root) {
          this.formsRoot = root;
          this.formsStyle = new CSSStyleSheet();
          this.formsStyle.replaceSync('@media(max-width:749px){[data-current-step="tease"]{bottom:var(--erten-sticky-offset,0px)!important;}}');
          root.adoptedStyleSheets = [...root.adoptedStyleSheets, this.formsStyle];
          clearInterval(this.formsTimer);
        } else if (++tries > 40) clearInterval(this.formsTimer);
      }, 500);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onChange);
      this.section?.removeEventListener('click', this.onClick, true);
      clearInterval(this.formsTimer);
      if (this.formsRoot) this.formsRoot.adoptedStyleSheets = this.formsRoot.adoptedStyleSheets.filter(sheet => sheet !== this.formsStyle);
      this.guide?.remove(); this.summary?.remove(); this.facts?.remove();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('erten-collection-offer')) {
  customElements.define('erten-collection-offer', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.erten-offer__grid');
      this.next = this.querySelector('.erten-offer__next');
      this.status = this.querySelector('[role="status"]');
      if (!this.next || !this.grid) return;
      this.onClick = (event) => { event.preventDefault(); this.loadMore(); };
      this.next.addEventListener('click', this.onClick);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadMore();
      }, { rootMargin: '120px 0px' });
      this.observer.observe(this.next);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.next?.removeEventListener('click', this.onClick);
    }
    async loadMore() {
      if (this.loading || !this.next || this.next.hidden) return;
      this.loading = true;
      this.observer?.unobserve(this.next);
      this.controller = new AbortController();
      this.status.textContent = 'Ürünler yükleniyor…';
      this.next.setAttribute('aria-disabled', 'true');
      try {
        const url = new URL(this.next.href, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Products unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.getElementById(this.id);
        if (!incoming) throw new Error('Section unavailable');
        const existing = new Set(Array.from(this.grid.children, item => item.dataset.offerProduct));
        const items = Array.from(incoming.querySelectorAll('[data-offer-product]')).filter(item => !existing.has(item.dataset.offerProduct));
        this.grid.append(...items);
        const next = incoming.querySelector('.erten-offer__next');
        if (next && items.length) {
          this.next.href = next.href;
          this.observer?.observe(this.next);
        } else {
          this.next.hidden = true;
          this.observer?.disconnect();
        }
        this.status.textContent = items.length ? `${this.grid.children.length} ürün gösteriliyor` : '';
      } catch (error) {
        if (error.name !== 'AbortError') this.status.textContent = 'Yüklenemedi. Devam etmek için tekrar dokunun.';
      } finally {
        this.loading = false;
        this.next.removeAttribute('aria-disabled');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
